import DsAtt from './DsAtt'

export default Vue => {
  Vue.component(DsAtt.name, DsAtt)
}



// WEBPACK FOOTER //
// ./src/components/dsatt/index.js